
import config from '@/api/base'
export function LocationManager (redirectPath) {

    let protocol = config.url.substr (0,5);
    // 根据协议选择不同的redirectUri
    let redirectUri = protocol === "https" ? config.https+redirectPath : config.http+redirectPath;

    window.location.href = redirectUri;
}

export default LocationManager;




